import React from 'react';
import { Route } from 'react-router-dom';
import InsightsRoutes from './Insights/routes';
const routes = () => [<InsightsRoutes key="InsightsRoutes" />];

const InsightRoute = () => <Route component={routes} />;

export default InsightRoute;



// WEBPACK FOOTER //
// src/modules/screens/insights/routes.js